import styled from "@emotion/styled";
import {mq} from "@styles/helpers";
import {Devices} from "@styles/tokens";
import Reset from "@assets/svg/match/reset.svg";
import AttendingIcon from "@assets/svg/match/attending.svg"
import EditIcon from "@assets/svg/edit.svg";
import MissingIcon from "@assets/svg/match/missing.svg"
import {colors} from "@styles/colors";

export const CourseContainer = styled('div', { shouldForwardProp: (prop) => prop !== 'headers' })<{even:boolean, headers:boolean}>`
    position: relative;
    width:100%;
    height:auto;
    display:grid;
    grid-template-columns: 1fr 150px 150px 30px 30px;
    font-weight: ${props => props.headers?"600":"300"};
    gap:20px;
    font-size: 24px;  
    align-items: center;
    color: ${props => props.headers?colors.mainTextColor:"#000"};
    border-bottom: ${props => props.headers?"2px solid #e3e3e3;":"1px solid #e3e3e3;"}
    padding: 0 10px;
    input {
      font-size: 18px;
      padding: 10px 6px;
      border-radius: 5px;     
    }  
  
    svg {
      width: 100%;
      max-width: 100%;
      max-height: 100%;
    }
  
  span{
    padding: 10px 0px;
  }

  

    ${mq(Devices.mobile)} {
      height:auto;
      grid-column: unset;
    }
`;

export const Close = styled(MissingIcon)`

  path {
    fill: ${colors.mainTextColor};
  }
`;

export const Cross = styled(Reset)`

  path {
    fill: ${colors.red};
  }
`;

export const Edit = styled(EditIcon)`

  path {
    fill: ${colors.mainTextColor};
  }
`;

export const Attending = styled(AttendingIcon)` 

  path {
    fill: ${colors.mainTextColor};
  }
`;

export const Button = styled.button`
  width: 30px;  
  height: 30px;
`;